export const navItems = [
  { path: '/', label: '首页' },
  { path: '/articles', label: '全部' },
  { path: '/articles', label: '技术', query: { type: 'tech' } },
  { path: '/articles', label: '软件', query: { type: 'software' } },
  { path: '/articles', label: '教程', query: { type: 'tutorial' } },
  { path: '/articles', label: '资源', query: { type: 'resource' } },
  { path: '/tools', label: '工具' }
]

export const softwareCategories = [
  { name: '全部', key: '', icon: 'el-icon-menu' },
  { name: '小工具', key: '小工具', icon: 'el-icon-scissors' },
  { name: '办公软件', key: '办公软件', icon: 'el-icon-notebook-2' },
  { name: '开发工具', key: '开发工具', icon: 'el-icon-s-tools' },
  { name: '系统工具', key: '系统工具', icon: 'el-icon-setting' },
  { name: '设计工具', key: '设计工具', icon: 'el-icon-brush' },
  { name: '效率工具', key: '效率工具', icon: 'el-icon-timer' }
]

export const tutorialCategories = [
  { name: '全部', key: '', icon: 'el-icon-menu' },
  { name: '入门教程', key: '入门教程', icon: 'el-icon-reading' },
  { name: '实战项目', key: '实战项目', icon: 'el-icon-s-cooperation' },
  { name: '进阶指南', key: '进阶指南', icon: 'el-icon-top' }
]

export const resourceCategories = [
  { name: '全部', key: '', icon: 'el-icon-menu' },
  { name: '学习资源', key: '学习资源', icon: 'el-icon-collection' },
  { name: '开源项目', key: '开源项目', icon: 'el-icon-link' },
  { name: '书籍推荐', key: '书籍推荐', icon: 'el-icon-notebook-1' }
]
